import { FunctionComponent, useEffect, useState } from "react";
import { Link } from "react-router";
import { observer } from "mobx-react-lite";

import { Skeleton } from "primereact/skeleton";

import { useWhitelabelService } from "../../../../services/ServiceHooks/whitelabelHook";
import { useStore } from "../../../../stores/StoreContext";

import "./CompanyLogo.scss";

const CompanyLogoRaw: FunctionComponent = () => {
  const { navigationStore, whitelabelStore } = useStore();
  const whitelabelService = useWhitelabelService();

  const [logo, setLogo] = useState<string | undefined>(
    whitelabelStore.appLogo && URL.createObjectURL(whitelabelStore.appLogo),
  );

  useEffect(() => {
    const loadLogo = async () => {
      await whitelabelService.getSettingImage();
    };

    if (!whitelabelStore.appLogo) {
      loadLogo();
    }
  }, []);

  useEffect(() => {
    if (whitelabelStore.appLogo) {
      setLogo(URL.createObjectURL(whitelabelStore.appLogo));
    }
  }, [whitelabelStore.appLogo]);

  if (!logo) {
    return (
      <div className="logo-container">
        <Skeleton width="9rem" height="80%" className="logo-skeleton" />
      </div>
    );
  }

  return (
    <Link to={navigationStore.landingPage.url ?? "/"}>
      <div className="logo-container">
        <img src={logo} alt="Company Logo" />
      </div>
    </Link>
  );
};

export const CompanyLogo = observer(CompanyLogoRaw);
